// Home.jsx
import React, { useState } from "react";
import { AppBar, Toolbar, Typography, Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import BasicTabs from "./BasicTabs";
import StandardList from "./StandardList";
import ScopeCalculator from "./ScopeCal/ScopeCal";
import UncertaintyCalculator from "./UncertaintyCalculator"; // ✅ new import

export default function Home({ setAuthenticated }) {
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState("Uncertainty Calculator");

  const handleLogout = async () => {
    try {
      const response = await fetch("/api/auth/logout", {
        method: "POST",
        credentials: "include",
      });
      if (response.ok) {
        setAuthenticated(false);
        navigate("/");
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      {/* AppBar */}
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            ISO17025 ACCREDITATION CALIBRATION
          </Typography>
          <Button color="inherit" onClick={handleLogout}>
            Logout
          </Button>
        </Toolbar>
      </AppBar>

      {/* Tabs */}
      <BasicTabs value={tabValue} onChange={setTabValue} />

      {/* Conditional page content */}
      {tabValue === "Uncertainty Calculator" && <UncertaintyCalculator />}
      {tabValue === "Scope Calculator" && <ScopeCalculator />}
      {tabValue === "Standard List" && (
        <Box sx={{ p: 3 }}>
          <StandardList />
        </Box>
      )}
    </Box>
  );
}